export const getAllGuestEmails = state => state.guestEmails;